import { render } from "./FrameBusPrc.vue?vue&type=template&id=2215869e&scoped=true"
import script from "./FrameBusPrc.vue?vue&type=script&lang=js"
export * from "./FrameBusPrc.vue?vue&type=script&lang=js"

import "./FrameBusPrc.vue?vue&type=style&index=0&id=2215869e&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2215869e"]])

export default __exports__